module.exports = __webpack_public_path__ + "img/icon-founded-light.d53dc215.svg";